import React from 'react';
import { Provider } from '../../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../../common/ComponentNameContext';
import Tab from '../../../common/tab';
import withTabAndRealTime from '../common/withTabAndRealtime';
import { indexMapFilter } from '../Const';
import AllExchanges from './AllExchanges';
import { connect } from 'react-redux';
import { subscribeRealtimeTickTopNewLow } from './reducer';
import ScrollComponent from './../../../common/ScrollComponent';
import { compose } from 'redux';
import PreRender from '../../../common/PreRender';
import ConstCommon from './../../../common/Const';
import Export from './Export';
import TabTimer from '../../../common/tab-timer';
import DropDownTimeRange from './DropDownTimeRange';

const TopNewLow = props => {
  const { indexTab, changeIndex, typeTab, changeType, id } = props;
  const filter = indexMapFilter[indexTab];

  return (
    <PreRender {...props}>
      <Provider value={id}>
        <ComponentNameProvider value={ConstCommon.listComponent.TopNewLow}>
          <ScrollComponent>
            <div
              className={`top-nav d-flex flex-column ${
                typeTab === 5 ? '' : 'h-100'
              }`}
            >
              <div className={`px-20 pt-8 ${typeTab === 5 ? 'sticky' : ''}`}>
                <Tab
                  currentTab={indexTab}
                  listTab="topVolume.tab"
                  changeTab={changeIndex}
                />
                <div className="justify-content-between list-filter top-nav">
                  <div className="d-flex">
                    <TabTimer
                      currentTab={typeTab}
                      listTab="topVolume.tabDataChange.tabDataChangeTab"
                      changeTab={changeType}
                    />
                    <div className="ml-1 mr-20">
                      <DropDownTimeRange comGroupCode={filter} />
                    </div>
                  </div>
                  <div style={{ paddingTop: 2, paddingLeft: 20 }}>
                    {typeTab !== 5 && (
                      <Export filter={filter} typeTab={typeTab} />
                    )}
                  </div>
                </div>
              </div>

              <div className="tab-content d-flex flex-column flex-fill">
                <AllExchanges
                  key={indexTab}
                  typeTab={typeTab}
                  filter={filter}
                />
              </div>
            </div>
          </ScrollComponent>
        </ComponentNameProvider>
      </Provider>
    </PreRender>
  );
};

const mapDispatchToProps = {
  dispatchRealtime: subscribeRealtimeTickTopNewLow,
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withTabAndRealTime(ConstCommon.listComponent.TopNewLow),
)(TopNewLow);
